<i18n>
{
    "en":{
      "please_input_captcha": "Please input the captcha",
      "error_captcha": "Captcha is wrong",
      "title": "Watch the AD to get free trial",
      "no_available_trial_device": "Due to high traffic at the moment, there are no available licenses. Please try again later, or subscribe now to enjoy your dedicated gaming robot!",
      "sub_title": "Watch the Full Introduction Video",
      "trial_plan_had_applied": "You already have a free trial license.",
      "paymentProblemQuestion": "Thank you very much for using our product, and we guarantee continued unlimited free trials. However, I would like to ask if you have encountered any difficulties in paying for it?",
      "other": "Other",
      "noCreditCard": "No credit card / debit card, unable to pay",
      "tooExpensive": "Too expensive",
      "submit": "Submit"
    },
    "zhHant":{
      "please_input_captcha": "請輸入驗證碼",
      "error_captcha": "驗證碼錯誤",
      "title": "看完廣告取得免費試用",
      "no_available_trial_device": "由於目前流量較高，暫時沒有免費授權釋出，請稍後再試，或現在立即訂閱享受您專屬的遊戲機器人管家！",
      "sub_title": "觀看完整介紹影片",
      "trial_plan_had_applied": "您已取得免費試用授權。",
      "paymentProblemQuestion": "非常感謝您使用我們的產品，我們保證持續提供無限次數的免費試用。不過想請問您對於付費使用方面，是否遇到什麼困難？",
      "other": "其他",
      "noCreditCard": "沒有信用卡/簽帳卡，無法付款",
      "tooExpensive": "覺得太貴",
      "submit": "提交"
    },
    "ja":{
      "please_input_captcha": "キャプチャを入力してください",
      "error_captcha": "キャプチャが間違っています",
      "title": "CMを見て 無料試用GET!",
      "no_available_trial_device": "無料トライアル版は皆様共にご利用頂きスペースです。現在ライセンスの空きがありません。早急に対応しますので、後ほど再度お試しねがいます。",
      "sub_title": "完全な紹介ビデオを見る",
      "trial_plan_had_applied": "お客様は現在無料トライアル中です。",
      "paymentProblemQuestion": "弊社製品をご利用いただき誠にありがとうございます。引き続き無制限の無料トライアルを保証します。ただし、支払いに関して何か困難に遭遇したかどうかをお聞きしたいのですが。",
      "other": "他の",
      "noCreditCard": "クレジットカード/デビットカードなしでは支払えない",
      "tooExpensive": "高すぎると思う",
      "submit": "提出"
    },
    "ko":{
      "please_input_captcha": "캡차를 입력하세요",
      "error_captcha": "캡차가 틀렸습니다",
      "title": "광고를 보고 무료로 써보세요",
      "no_available_trial_device": "우리 서버의 시험 사용 공간이 부족합니다. 잠시 후 다시 시도하거나 지금 바로 구독을 선택하세요.",
      "sub_title": "전체 소개 비디오 시청하기",
      "trial_plan_had_applied": "무료로 시험 사용 허가를 받았습니다",
      "other": "다른",
      "paymentProblemQuestion": "저희 제품을 이용해 주셔서 진심으로 감사드리며, 지속적인 무제한 무료 평가판을 보장합니다. 그런데 혹시 결제하는데 어려움은 없으셨는지 여쭤보고 싶습니다.",
      "noCreditCard": "신용/직불카드 없이는 결제가 불가능합니다.",
      "tooExpensive": "너무 비싸다고 생각하세요",
      "submit": "제출"
    }
}
</i18n>
<template>
  <v-layout column fill-height justify-space-between>
    <div v-if="showCaptcha" class="text-xs-center" style="margin-top: 200px">
      <canvas width="240" height="90" id="captcha1"></canvas>
      <v-text-field
        v-model="captchaValue"
        @input="onInputCaptcha"
        :label="$t('please_input_captcha')"
        :error-messages="captchaError"
        style="margin-left: 40px; margin-right: 40px"
      ></v-text-field>
    </div>
    <div v-if="showAd">
      <div class="text-xs-center" style="margin-top: 20px; font-size: 20px; padding: 0 20px">
        {{ this.$i18n.t('title') }}
      </div>

      <div style="display: flex; flex-direction: column; justify-content: center; flex-grow: 1">
        <div style="display: flex; flex-direction: column; align-items: center">
          <iframe
            style="max-width: 560px; width: 100%; height: 315px; border: 0"
            :src="`https://www.youtube.com/embed/${youtubeID}?autoplay=1&mute=1`"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <a :href="`https://www.youtube.com/watch?v=${youtubeID}`" target="_blank" style="text-decoration: none">
            <div style="color: #3874cb; font-size: 20px; margin-top: 20px">
              {{ this.$i18n.t('sub_title') }}
            </div>
          </a>
        </div>
      </div>

      <v-progress-linear height="2" v-model="progressLinearValue" color="cyan" style="margin-bottom: 0">
      </v-progress-linear>

      <!-- survey dialog -->
      <v-dialog v-model="isSurveyDialogOpen" persistent max-width="400">
        <v-card>
          <v-card-title>{{ $t('paymentProblemQuestion') }}</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="isPaymentReasonValid" lazy-validation>
              <v-radio-group v-model="paymentReason" validate-on-blur :rules="paymentReasonFormRules">
                <v-radio :label="$t(reasons.noCreditCard)" :value="reasons.noCreditCard" />
                <v-radio :label="$t(reasons.tooExpensive)" :value="reasons.tooExpensive" />
                <v-radio :label="$t(reasons.other)" :value="reasons.other" />
                <v-textarea outline v-model="otherReason" :rules="otherReasonRules" />
              </v-radio-group>
            </v-form>
            <HighPriceHint :isShow="paymentReason === reasons.tooExpensive" :supportGame="supportGame" />
            <NoCreditCardHint :isShow="paymentReason === reasons.noCreditCard" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              :color="isPaymentReasonValid ? 'primary' : 'blue-grey lighten-4'"
              outline
              @click="submitSurvey"
              >{{ $t('submit') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions';
import HighPriceHint from '../components/HighPriceHint';
import NoCreditCardHint from '../components/NoCreditCardHint';
import CaptchaMini from 'captcha-mini';

const xApplyTrialPlan = firebase.functions().httpsCallable('xApplyTrialPlan');
const xCheckTrialPlan = firebase.functions().httpsCallable('xCheckTrialPlan');

export default {
  name: 'trial',
  components: {
    HighPriceHint,
    NoCreditCardHint,
  },
  data() {
    return {
      showCaptcha: false,
      showAd: false,
      captchaAnswer: '',
      captchaValue: '',
      catchaError: '',
      waitTime: 45000,
      progressLinearValue: 100,
      countdownTimer: undefined,
      youtubeID: undefined,
      youtubePossibleIDs: {
        tsum: {
          en: ['JSmbshC4TDE'],
          zhHant: ['JSmbshC4TDE'],
          ja: ['8dAU4LLraWs', 'yjivg-L9opI', 'nAmCZay2Zs8', 'JSmbshC4TDE'],
          ko: ['JSmbshC4TDE'],
        },
        cookieKingdom: {
          en: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          zhHant: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          ja: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          ko: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
        },
        mlb9i: {
          en: ['8dAU4LLraWs'],
          zhHant: ['8dAU4LLraWs'],
          ja: ['8dAU4LLraWs'],
          ko: ['8dAU4LLraWs'],
        },
      },
      isSurveyDialogOpen: false,
      reasons: {
        noCreditCard: 'noCreditCard',
        tooExpensive: 'tooExpensive',
        other: 'other',
      },
      paymentReason: undefined,
      otherReason: '',
      isPaymentReasonValid: false,
      paymentReasonFormRules: [v => v === this.reasons.other && !this.otherReason.trim() && '', v => !v && ''],
      otherReasonRules: [v => this.paymentReason === this.reasons.other && !v && ''],
    };
  },
  async mounted() {
    this.supportGame = this.$route.params.supportGame;
    if (this.supportGame !== 'tsum' && this.supportGame !== 'cookieKingdom' && this.supportGame !== 'mlb9i') {
      this.$router.push({ name: 'home' });
      return;
    }
    await this.checkFreeTrial();
  },
  methods: {
    countdown() {
      if (this.countdownTimer !== undefined) {
        return;
      }
      const now = Date.now();
      this.countdownTimer = setInterval(async () => {
        this.progressLinearValue = 100 - ((Date.now() - now) / this.waitTime) * 100;
        if (this.progressLinearValue <= 0) {
          clearInterval(this.countdownTimer);
          this.progressLinearValue = 0;
          await this.applyFreeTrial();
        }
      }, 1000);
    },
    handleTrialError(error) {
      let code = error.code;
      if (code === 'already-exists') {
        alert(this.$i18n.t('trial_plan_had_applied'));
      } else if (code === 'resource-exhausted') {
        alert(this.$i18n.t('no_available_trial_device'));
      } else if (error === 'failed-precondition') {
        this.$router.push('/login');
      } else {
        alert(error);
      }
    },
    async onInputCaptcha() {
      if (this.captchaAnswer === this.captchaValue) {
        this.showCaptcha = false;
        this.showAd = true;

        // trial times >= 10
        this.$gtag.event('freeTrial', 'issueSuccess', 'showAds', 1);
        const hasFinishSurvey = localStorage.getItem('hasFinishSurvey');
        if (hasFinishSurvey === null) {
          this.isSurveyDialogOpen = true;
        } else {
          const links = this.youtubePossibleIDs[this.supportGame][this.$i18n.locale];
          if (links.length > 0) {
            const randomIndex = Math.floor(Math.random() * links.length);
            this.youtubeID = links[randomIndex];
          }
          this.countdown();
        }
      } else {
        if (this.captchaValue.length >= 4) {
          this.captchaError = this.$t('error_captcha');
        }
      }
    },
    async checkFreeTrial() {
      let result;
      try {
        result = await xCheckTrialPlan({
          supportGame: this.supportGame,
        });
      } catch (error) {
        this.$gtag.event('freeTrial', 'issueError', error.code, 1);
        this.handleTrialError(error);
        this.$router.push({ name: 'home' });
        return;
      }
      const showAd = result.data ? result.data.showAd : false;
      if (!showAd) {
        await this.applyFreeTrial();
        return;
      }

      this.showCaptcha = true;
      this.$nextTick(() => {
        let captcha1 = new CaptchaMini();
        captcha1.draw(document.querySelector('#captcha1'), r => {
          this.captchaValue = '';
          this.captchaError = '';
          this.captchaAnswer = r;
        });
      });
    },
    async applyFreeTrial() {
      try {
        await xApplyTrialPlan({
          supportGame: this.supportGame,
        });
        this.$gtag.event('freeTrial', 'issueSuccess', 'noShowAds', 1);
        this.$router.push({ name: 'home' });
      } catch (error) {
        this.$gtag.event('freeTrial', 'issueError', error.code, 1);
        this.handleTrialError(error);
        this.$router.push({ name: 'home' });
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    async submitSurvey() {
      if (!this.validate()) {
        return;
      }

      try {
        localStorage.setItem('hasFinishSurvey', true);
        const userInputReason =
          this.paymentReason === this.reasons.other ? this.otherReason : this.$t(this.paymentReason);
        const formContent = new FormData();

        formContent.append('UserID', firebase.auth().currentUser.uid);
        formContent.append('Name', firebase.auth().currentUser.displayName);
        formContent.append('Email', firebase.auth().currentUser.email);
        formContent.append('Message', userInputReason);
        formContent.append('Time', new Date().toISOString());

        fetch(
          'https://script.google.com/macros/s/AKfycby5WHqPJqYntaCnaGS1YhKuDQ2A5hktCLnGvSMyG5WcyGE56xNsgsS-_7wbWwPTddAg/exec',
          {
            method: 'POST',
            body: formContent,
          }
        );
      } catch (error) {
        console.error('send reason to google sheet failed: ', error);
      }
      this.isSurveyDialogOpen = false;
      await this.applyFreeTrial();
      this.$router.push({ name: 'home' });
    },
  },
  beforeDestroy() {
    // deconstruction here!!
    clearInterval(this.countdownTimer);
  },
};
</script>
